import { render, staticRenderFns } from "./CsvHistory.vue?vue&type=template&id=435c5c3f&scoped=true&"
import script from "./CsvHistory.vue?vue&type=script&lang=js&"
export * from "./CsvHistory.vue?vue&type=script&lang=js&"
import style0 from "./CsvHistory.vue?vue&type=style&index=0&id=435c5c3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435c5c3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
